import { useEffect } from 'react';
import { CustomEventEnum } from 'utils/events/eventUtils';
import { MarketDayEventEnum } from 'utils/marketDayMilestonesTracking/marketDayMilestonesTrackingUtils';

// ==============================|| HOOK ||============================== //

const useEventListener = (
  customEvents: (CustomEventEnum | MarketDayEventEnum)[],
  eventHandler: (...args: any[]) => void
) => {
  useEffect(() => {
    const eventTypes = Object.values(customEvents);

    eventTypes.forEach((eventType) => {
      window.addEventListener(eventType, eventHandler);
    });

    return () => {
      eventTypes.forEach((eventType) => {
        window.removeEventListener(eventType, eventHandler);
      });
    };
  }, [customEvents, eventHandler]);
};

export default useEventListener;
